export default {"src":"/_next/static/media/visonum.ca8575c6.svg","height":24,"width":159};